<template>
    <div class="componentRoot">
        <ButtonRowVue>
            <template v-slot:leftSide>
                <v-col :cols="searchBarCols" class="pr-2">
                    <SearchBarVue :labelArray="['basics.name', 'basics.type']" @search="updateSearchQueue" />
                </v-col>
                <v-col v-if="activeType" cols="auto" style="display: flex; align-items: center;">
                    <v-card flat style="display: flex; align-items: center;" class="px-4">
                        <v-chip :color="activeType.color_code" @click="filterByType($event, activeType)">{{
                            activeType.name
                            }} <v-icon>mdi-close</v-icon></v-chip>
                    </v-card>
                </v-col>
            </template>


            <v-col cols="auto" v-if="!profileView && $checkRouterPermission('POST')">
                <v-tooltip :text="$t('basics.new', { type: $t('basics.digitalMedia') })">
                    <template v-slot:activator="{ props }">
                        <v-btn v-bind="props" @click="showEditDigitalMedia($event)" class="primaryButton squareButton"
                            flat><v-icon size="x-large">mdi-plus</v-icon></v-btn>
                    </template>
                </v-tooltip>
            </v-col>
        </ButtonRowVue>
        
        <TableVue v-if="!profileView" :numPages="numPages" @switchPage="switchPage" id="digitalmediaTable" :resetPage="resetPage"
            :total="totalCount">
            <thead>
                <tr>
                    <th>
                        <b style="font-size: medium">{{ $t("basics.type") }}</b>
                    </th>
                    <th class="text-left" @click="switchSortBy('name')" :style="{
                        color: sortBy == 'name' ? 'rgb(var(--v-theme-primary))' : 'unset',
                    }">
                        <div style="display: flex; align-items: center">
                            <b style="font-size: medium">{{ $t("basics.name") }}</b>

                            <div v-if="sortBy == 'name'">
                                <v-icon v-if="!sortDirection">mdi-menu-up</v-icon>
                                <v-icon v-else>mdi-menu-down</v-icon>
                            </div>
                            <div v-else>
                                <v-icon>mdi-menu-right</v-icon>
                            </div>
                        </div>
                    </th>
                    <th v-if=!isMobile>
                        <b style="font-size: medium">{{ $t("basics.description") }}</b>
                    </th>
                    <th v-if="!isMobile" class="text-left" @click="switchSortBy('price')" :style="{
                        color: sortBy == 'price' ? 'rgb(var(--v-theme-primary))' : 'unset',
                    }">
                        <div style="display: flex; align-items: center">
                            <b style="font-size: medium">{{ $t("basics.price") }}</b>
                            <div v-if="sortBy == 'price'">
                                <v-icon v-if="!sortDirection">mdi-menu-up</v-icon>
                                <v-icon v-else>mdi-menu-down</v-icon>
                            </div>
                            <div v-else>
                                <v-icon>mdi-menu-right</v-icon>
                            </div>
                        </div>
                    </th>
                    <th> <b style="font-size: medium">{{ $t("basics.status") }}</b></th>
                    <th></th>
                </tr>
            </thead>
            <tbody v-if="digitalmedias && digitalmedias.length > 0">
                <tr v-for="digitalmedia in digitalmedias" 
                @click="gotoDigitalMedia($event, digitalmedia)" @mousedown.middle="gotoDigitalMediaInNewTab($event, digitalmedia)" :key="digitalmedia.id"
                >
                    <td>
                        <v-chip :color="digitalmedia.type.color_code" @click="filterByType($event, digitalmedia.type)">{{
                            digitalmedia.type.name }}</v-chip>
                    </td>
                    <td>
                        {{ digitalmedia.name }}
                    </td>
                    <td  v-if=!isMobile>
                        <span v-if="digitalmedia.description && digitalmedia.description.length > 60">
                            {{ digitalmedia.description.substring(0,50) }}...
                        </span>
                         <span v-else-if="digitalmedia.description">
                            {{ digitalmedia.description }}...
                        </span>
                    </td>
                    <td  v-if=!isMobile>
                        {{ digitalmedia.price }}€<span v-if="digitalmedia.is_subscription"> / Monat</span>
                        <v-chip size="small" class="ml-2">{{ digitalmedia.is_subscription ? "Abo" : "Einmalzahlung" }}</v-chip>
                    </td>

                    <td>
                        <v-chip :color="statusColors[digitalmedia.status]">{{ $t("constants.product_status_" +
                            digitalmedia.display_status) }}</v-chip>
                    </td>
                    <td class="text-right">
                        <v-tooltip :text="$t('basics.edit', { type: $t('basics.digitalmedia') })"  v-if="$checkRouterPermission('PATCH')">
                            <template v-slot:activator="{ props }">
                                <div @click="showEditDigitalMedia($event, digitalmedia)" :key="digitalmedia.id">
                                <v-icon v-bind="props"> mdi-pencil </v-icon>
                                </div>
                            </template>
                        </v-tooltip>
                    </td>
                </tr>
            </tbody>

            <tbody v-else>
                <tr>
                    <td colspan="400">
                        <i>{{ $t("messages.noItems") }}</i>
                    </td>
                </tr>
            </tbody>
        </TableVue>
        
        <template v-if="profileView">
            <template v-if="digitalmedias && digitalmedias.length">
                <v-btn variant="text" class="mt-2 mb-3" @click="switchSortBy('name')">
                    {{ $t('basics.name') }}
                    <v-icon end>{{ sortDirection ? 'mdi-menu-down' : 'mdi-menu-up' }}</v-icon>
                </v-btn>

                <v-expansion-panels variant="accordion" v-if="bundleGroups.length" multiple class="mb-4" flat v-model="panels">
                    <v-expansion-panel v-for="group in bundleGroups" :key="group.id" :value="group.id" class="mb-2">
                        <v-expansion-panel-title>{{ group.name }}</v-expansion-panel-title>
                        <v-expansion-panel-text>
                            <DigitalMediaCards :items="group.items" :imageForMedia="getMediaImage"
                    @open="gotoDigitalMedia" @open-new-tab="gotoDigitalMediaInNewTab"
                    @filter="filterByType" @image-error="useFallbackImage" />
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                    <v-expansion-panel v-if="otherItems.length" value="other">
                        <v-expansion-panel-title>{{ $t('basics.otherContents') }}</v-expansion-panel-title>
                        <v-expansion-panel-text>
                            <DigitalMediaCards :items="otherItems" :imageForMedia="getMediaImage"
                    @open="gotoDigitalMedia" @open-new-tab="gotoDigitalMediaInNewTab"
                    @filter="filterByType" @image-error="useFallbackImage" />
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                </v-expansion-panels>
                <DigitalMediaCards v-else :items="digitalmedias" :imageForMedia="getMediaImage"
                    @open="gotoDigitalMedia" @open-new-tab="gotoDigitalMediaInNewTab"
                    @filter="filterByType" @image-error="useFallbackImage" />
            </template>
            <v-row v-else-if="!loading">
                <v-col cols="12" class="text-center"><i>{{ $t('messages.noItems') }}</i></v-col>
            </v-row>
            <v-pagination v-if="numPages > 1" :model-value="currPage" :length="numPages"
                :total-visible="isMobile ? 3 : 7" class="mt-4" @update:model-value="switchPage" />
        </template>

        <DigitalMediaEditVue :refreshDisplay="editDigitalMediaDrawer" @close="closeEditDigitalMedia" :digitalMediaData="activeDigitalMedia"
            @delete="showDeleteDigitalMedia"
            :readonly="!$checkRouterPermission('POST') && !$checkRouterPermission('PATCH')" />

        <DeletionWarningVue :type="'digitalMedia'" :additionalMessage="$t('messages.confirmDeletionItem', { item: activeDigitalMedia?.name })
            " :refreshDisplay="deleteDigitalMediaDrawer" @delete="deleteDigitalMedia" style="z-index: 1007 !important" />

        <LoadingScreenVue :loading="loading" />
    </div>
</template>

<script>
import DigitalMediaCards from "./DigitalMediaCards.vue";
import DigitalMediaEditVue from "../../../components/products/DigitalMediaEdit.vue";

export default {
    name: "digitalmediaList",

    data() {
        return {
            digitalmedias: undefined,
            profileRequestId: 0,

            activeDigitalMedia: undefined,
            editDigitalMediaDrawer: 0,
            deleteDigitalMediaDrawer: 0,

            currPage: 1,
            numPages: undefined,
            totalCount: undefined,
            resetPage: 0,

            activeType: undefined,

            searchQueue: undefined,
            searchParams: undefined,

            filterParams: undefined,

            sortBy: "name",
            sortDirection: true,

            panels: [],

            loading: false,

            statusColors: [
                "rgb(var(--v-theme-success))",
                "rgb(var(--v-theme-error))",
            ]
        };
    },

    computed: {
        bundleGroups() {
            const groups = new Map();
            for (const item of this.digitalmedias || []) {
                for (const bundle of item.owned_bundles || []) {
                    if (!groups.has(bundle.id)) groups.set(bundle.id, { id: bundle.id, name: bundle.name, items: [] });
                    const group = groups.get(bundle.id);
                    if (!group.items.some(media => media.id === item.id)) group.items.push(item);
                }
            }

            return [...groups.values()];
        },
        otherItems() {
            return (this.digitalmedias || []).filter(item => !(item.owned_bundles || []).length);
        },
        profileView(){
            return String(this.$route.name || "").includes("user")
        },
        isMobile() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return true;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
        searchBarCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 9;
                case "sm":
                    return 6;
                case "md":
                    return 4;
                case "lg":
                    return 4;
                case "xl":
                    return 4;
                case "xxl":
                    return 3;
                default:
                    return 4;
            }
        },
    },

    components: {
        DigitalMediaEditVue,
        DigitalMediaCards,
    },

    methods: {
        getMediaImage(media) {
            if (media.banner_image_64) return media.banner_image_64;
            if (!media.banner_image) return '/images/main/background.jpeg';
            return new URL(media.banner_image, this.axios.defaults.url || window.location.origin).href;
        },
        useFallbackImage(event) {
            const image = event.target;
            if (image.dataset.fallbackApplied) return;
            image.dataset.fallbackApplied = 'true';
            image.src = '/images/main/background.jpeg';
        },
        filterByType(event, type) {
            event.stopPropagation()
            event.preventDefault()

            if (this.activeType && this.activeType.id == type.id) {
                this.activeType = undefined
            }
            else {
                this.activeType = type
            }

            this.currPage = 1;
            this.resetPage++;
            this.fetchData()
        },
        getIcon(digitalmedia) {
            switch (digitalmedia.display_type) {
                case "hotel":
                    return "mdi-bunk-bed";
                case "campus":
                    return "mdi-table-chair";
                case "gym":
                    return "mdi-garage-open-variant";
                case "multiUse":
                    return "mdi-dots-horizontal-circle-outline";
                case "external":
                    return "mdi-open-in-new";
                default:
                    return "mdi-table-chair";
            }
        },
        fetchData() {
            this.setLoading(true);

            let searchParams =
                "?page=" +
                this.currPage +
                "&order=" +
                this.sortBy +
                "&direction=" +
                (this.sortDirection ? "up" : "down");

            if (this.searchParams) {
                searchParams += this.searchParams;
            }

            if (this.searchQueue) {
                searchParams += "&query=" + this.searchQueue;
            }

            if (this.filterParams) {
                searchParams += this.filterParams;
            }

            if (this.activeType) {
                searchParams += "&type=" + this.activeType.id
            }

            let url = ""
            if(this.profileView){
                url = "own/"
            }

            const endpoint = this.axios.defaults.baseURL + "media/digitalmedias/" + url + searchParams;
            if (this.profileView) {
                // Load all matching pages so a purchased bundle is never split between panels/pages.
                this.fetchProfilePages(endpoint);
                return;
            }
            this.axios.get(endpoint)
                .then((resp) => {
                    this.digitalmedias = resp.data.results;
                    this.totalCount = resp.data.count;
                    if (resp.data.results.length === 0) this.numPages = 0;
                    else if (this.currPage === 1) this.numPages = Math.ceil(resp.data.count / resp.data.results.length);
                })
                .catch((error) => {
                    window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: error }));
                })
                .finally(() => { this.setLoading(false); });
        },
        async fetchProfilePages(url) {
            const requestId = ++this.profileRequestId;
            try {
                const items = [];
                while (url) {
                    const { data } = await this.axios.get(url);
                    if (requestId !== this.profileRequestId) return;
                    items.push(...(data.results ?? data));
                    url = data.next || null;
                }
                this.digitalmedias = items;
                this.totalCount = items.length;
                this.currPage = 1;
                this.numPages = items.length ? 1 : 0;

                
                    if(this.profileView){
                        this.$nextTick(() => {
                            this.panels = []
                            for(let i = 0; i < this.bundleGroups.length; i++){
                                this.panels.push(this.bundleGroups[i].id)
                            }
                            this.panels.push("other")
                        })
                    }
            } catch (error) {
                if (requestId === this.profileRequestId) window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: error }));
            } finally {
                if (requestId === this.profileRequestId) this.setLoading(false);
            }
        },
        setLoading(value) {
            this.loading = value;
        },
        showEditDigitalMedia(event, digitalmedia) {
            event.preventDefault();
            event.stopPropagation();

            this.activeDigitalMedia = digitalmedia;
            this.editDigitalMediaDrawer++;
        },
        gotoDigitalMedia(event, digitalmedia) {
            event.preventDefault();
            event.stopPropagation();

            if(!this.$checkFunctionPermission(["digital_media_detail"])){
                this.showEditDigitalMedia(event, digitalmedia)
                return
            }
            

            if(this.profileView){
                this.$router.push("/main/digitalmedias/" + digitalmedia.id)
            }
            else{
                this.$router.push("/backoffice/products/digital/" + digitalmedia.id)
            }
        },
        gotoDigitalMediaInNewTab(event, digitalmedia) {
            event.preventDefault();
            event.stopPropagation();

            if(!this.$checkFunctionPermission(["digital_media_detail"])){
                return
            }

            window.open("/backoffice/products/digital/" + digitalmedia.id, "blank")
        },
        closeEditDigitalMedia(value) {
            this.activeDigitalMedia = undefined;
            this.editDigitalMediaDrawer = 0;

            this.setLoading(false);

            if (value) {
                this.fetchData();
            }
        },
        switchPage(data) {
            this.currPage = data;

            this.fetchData();
        },
        getReadableDatetime(datetime) {
            if (datetime) return this.$moment(datetime).format("DD.MM.YYYY HH:mm");
            else return undefined;
        },
        updateSearchQueue(value) {
            this.resetPage++;
            this.currPage = 1;
            this.searchQueue = value;

            this.fetchData();
        },
        switchSortBy(val) {
            if (this.sortBy != val) {
                this.sortBy = val;
                this.sortDirection = true;
            } else {
                this.sortDirection = !this.sortDirection;
            }

            this.currPage = 1;
            this.resetPage++;

            this.fetchData();
        },
        applyFilter(query) {
            this.resetPage++;
            this.filterParams = query;
            this.fetchData();
        },
        showDeleteDigitalMedia() {
            this.deleteDigitalMediaDrawer++;
        },
        deleteDigitalMedia() {
            this.setLoading(true);
            this.axios
                .patch(
                    this.axios.defaults.baseURL +
                    "media/digitalmedias/delete/" +
                    this.activeDigitalMedia.id,
                    {
                        deleted: true,
                    }
                )
                .then(() => {
                    this.setLoading(false);
                    this.deleteDigitalMediaDrawer = 0;
                    this.editDigitalMediaDrawer = 0;
                    this.fetchData();
                })
                .catch((e) => {
                    this.setLoading(false);
                    console.log(e);
                    window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
                });
        },
    },
    mounted() {
        this.fetchData();
    },
};
</script>

